module.exports = "pegasus_template/assets/blocks/capture-11-basic.png";